export const faqItems = [
  {
    question: '高义白洁这个词最早出自哪里？',
    answer: '高义白洁并非出自单一一部经典，而是由"高义"和"白洁"两个概念在中华文化发展过程中逐渐融合而成。"高义"最早可追溯至《周易》中关于崇高道德追求的论述，"白洁"则源自《楚辞》中以香草美人比喻高洁品格的文学传统。两者在后世文人的创作中被不断结合使用，最终形成了这一形容君子品格的经典词汇。',
  },
  {
    question: '高义白洁与现代生活有什么关系？',
    answer: '高义白洁的精神在现代社会依然具有重要价值。它提醒我们在追求物质成功的同时不忘精神建设，在商业活动中坚守诚信原则，在人际交往中保持真诚正直。无论是职场中的职业道德、商业中的公平竞争，还是日常生活中的自律自省，都是高义白洁精神在现代社会的具体体现。',
  },
  {
    question: '如何在日常生活中践行高义白洁？',
    answer: '践行高义白洁可以从以下几个方面入手：第一，坚持每日读书学习，提升道德修养；第二，养成自省习惯，每日反思言行是否符合道义；第三，从小事做起，如诚实守信、助人为乐、清廉自守；第四，远离不良诱惑，保持内心纯净；第五，以优秀传统文化滋养心灵，如阅读经典、欣赏高雅艺术。',
  },
  {
    question: '高义白洁与"君子"有什么关系？',
    answer: '高义白洁是对君子品格的集中概括和最高赞誉。在儒家思想中，君子是理想人格的代表，而高义白洁恰恰描绘了君子最核心的品质——既有超越功利的道义追求（高义），又有纯净无瑕的道德操守（白洁）。可以说，达到高义白洁境界的人，就是儒家理想中的君子。',
  },
  {
    question: '历史上哪些人物最能代表高义白洁的精神？',
    answer: '中国历史上有许多高义白洁的代表人物，最著名的包括：以生命殉道的屈原、不为五斗米折腰的陶渊明、精忠报国的岳飞、"人生自古谁无死，留取丹心照汗青"的文天祥，以及清正廉洁的海瑞、于谦等。他们虽然生活在不同时代，但都以各自的方式诠释了高义白洁的崇高精神。',
  },
  {
    question: '高义白洁是不是一种过于理想化的追求？',
    answer: '高义白洁确实代表了一种崇高的道德理想，但这并不意味着它是无法企及的。传统文化的智慧恰恰在于，它将最高远的理想落实到最日常的实践之中。正如《中庸》所言"道不远人"，高义白洁的修养不是一蹴而就的飞跃，而是在日常生活中日积月累的渐进过程。每个人都可以朝着这个方向努力，每一步都是对自我的超越。',
  },
];